// extracted by mini-css-extract-plugin
export default {"root":"mUAeCd","blockInfo":"HPIvUY","imgBlock":"XDVIb7","icon":"SkDw0o","positive":"h9UXl1","negative":"z_7I1E","title":"GM0OhY","row":"VWx4qz","quantity":"W8WhTD"};